import {
  Id,
  Identifiable,
  Log,
  LogType,
  Project,
  Resource,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedResource } from "../linkers/types";

type Response = {
  _embedded?: {
    logs: Identifiable<LinkedResource<Log>>[];
  };
  page: {
    totalPages: number;
  };
};

function getPlanzoneLogs(httpClient: HttpClient) {
  return (
    planzoneId: Id,
    pageSize: number,
    pageIndex: number,
    logTypesFilter: LogType[],
  ) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/logs/search/rsql?query=planzone.uuid==${planzoneId} ${
          logTypesFilter.length ? "and" : ""
        } ${logTypesFilter
          .map((log) => `logType==${log}`)
          .join(" or ")}&size=${pageSize}&page=${pageIndex}`,
        method: HttpMethods.GET,
      })
      .then(({ _embedded, page }) => {
        if (!_embedded) {
          return {
            pages: page.totalPages,
            logs: [],
            pageIndex,
          };
        }
        return Promise.all(
          _embedded.logs.map((log) =>
            httpClient
              .sendHttpRequest<Identifiable<Resource>>({
                endpoint: log._links.author.href,
                method: HttpMethods.GET,
                baseUrl: "",
              })
              .then((resource) => ({ ...log, author: resource }))
              .then((response) =>
                log.logType === "TASK" ||
                log.logType === "EVENT" ||
                log.logType === "MILESTONE" ||
                log.logType === "ACTIVITY" ||
                log.logType === "PROJECT"
                  ? httpClient
                      .sendHttpRequest<Identifiable<Project>>({
                        endpoint: log._links.project.href,
                        method: HttpMethods.GET,
                        baseUrl: "",
                      })
                      .then((project) => ({ ...response, project }))
                      .catch(() => response)
                  : response,
              ),
          ),
        ).then((logsWithAuthors) => ({
          pages: page.totalPages,
          logs: logsWithAuthors,
          pageIndex,
        }));
      });
}

export { getPlanzoneLogs };
